import { FC, useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';

import LocationAutoSelect from '../LocationAutoSelect';
import { useGetAirlinesQuery } from '../../store/services/tripsApi';

import styles from '../AirportSelect/AirportSelect.module.scss';

interface AirlineSelectProps {
  name: string;
  inputLabel: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onDetailsChange?: (details: { name: string; iata_code: string } | null) => void;
  error?: string;
  details?: { name: string; iata_code: string } | null;
}

const AirlineSelect: FC<AirlineSelectProps> = ({
  name,
  inputLabel,
  value,
  onChange,
  onDetailsChange,
  details,
  error,
}) => {
  const [airlineInput, setAirlineInput] = useState('');
  const [airlineSearch, setAirlineSearch] = useState('');

  const { data: airlines } = useGetAirlinesQuery(
    {
      search: airlineSearch,
    },
    {
      skip: !airlineSearch || airlineSearch.trim() === '',
    }
  );

  useEffect(() => {
    const timeout = setTimeout(() => {
      setAirlineSearch(airlineInput);
    }, 500);

    return () => clearTimeout(timeout);
  }, [airlineInput]);

  const handleChange = (
    event: React.SyntheticEvent<Element, Event>,
    selectedValue: { name: string; iata_code: string } | null
  ) => {
    const syntheticEvent = {
      target: {
        name,
        value: selectedValue ? selectedValue.iata_code : '',
      },
    } as React.ChangeEvent<HTMLInputElement>;

    onChange(syntheticEvent);

    onDetailsChange?.(selectedValue);
  };

  const currentAirline = details || airlines?.find(airline => airline.iata_code === value);

  return (
    <Box
      className={styles.customSelectContainer}
      data-invalid={error ? 'true' : undefined}
    >
      <LocationAutoSelect
        options={airlines ?? []}
        inputLabel={inputLabel}
        placeholder="Enter airline name"
        handleChange={handleChange}
        invalid={!!error}
        onInputChange={(event, inputValue) => {
          setAirlineInput(inputValue);
        }}
        value={currentAirline || null}
        customClass={styles.customInput}
      />
      {error && (
        <Typography
          variant="h12"
          sx={{ color: '#C8102E', mt: 1 }}
        >
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default AirlineSelect;
